import { Box, Chip, FormControl, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LeftArrow from '../../../../../../../asset/svg/leftArrow.svg';
import '../../../../../../../scss/pages/Attendance/Component/Asset/Assets/De-Register Asset/De-Register/deRegisterAsset.scss';
import SearchIcon from '@mui/icons-material/Search';
import requestEmptyIcon from '../../../../../../../asset/svg/requestEmptyIcon.svg';
import { ASSETS_REGISTER_PATH, DE_REGISTER_ASSET_INFO_PATH } from '../../../../../../../utils/Constants';
import { CLEAR_DE_REGISTER_ASSET_STATE, GET_FILTERED_DE_REGISTER_ASSET_DATA, GET_ISSUED_STORE_DOWNLOAD_QR, HIDE_MODAL_SELECT_STORE, SELECTED_ASSET_INFO_DE_REGISTER, SHOW_MODAL_ASSETGROUP } from '../../../../../../../sagas/type';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

function DeRegisterAsset() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { IssuedStoreDataDownloadQr, SelectedStoreDatas } = useSelector(mapStateToProps)
    const [searchName, setSearchName] = useState('')

    const handleClickFRegisteredAsset = (id) => {
        if (id) {
            dispatch({
                type: SELECTED_ASSET_INFO_DE_REGISTER,
                payload: { SelectedAssetId: id },
            })
            dispatch({
                type: GET_FILTERED_DE_REGISTER_ASSET_DATA,
                payload: { SelectedAssetId: id },
            })
            navigate(DE_REGISTER_ASSET_INFO_PATH)
        }
    }

    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }

    const handleBack = () => {
        dispatch({ type: CLEAR_DE_REGISTER_ASSET_STATE })
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
    }

    return (
        <>
            <div className='De-RegisterAsset-Container' >
                <div className='De-RegisterAsset-Container_header'>
                    <div className='De-RegisterAsset-Container_head-height '>
                        <img className='De-RegisterAsset-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='De-RegisterAsset-Container_header_content'>Registered Assets</span>
                    </div>
                    <div>
                        {SelectedStoreDatas && SelectedStoreDatas?.length && <Stack direction="row" spacing={1} sx={{ width: "fit-content", height: "22px", display: "flex", justifyContent: "center", alignItems: "center", marginRight: "10%" }} className='Download-QR-Container_Stock-chip'>
                            <Chip label={SelectedStoreDatas && SelectedStoreDatas?.length && SelectedStoreDatas[0]?.name} className='Download-QR-Container_Store-chip' sx={{ color: "#12B9DD", fontSize: "10px", fontWeight: 500, border: "none" }} variant="outlined" />
                        </Stack>}
                    </div>
                </div>
                <div className='De-RegisterAsset-Container_searchcontainer'>
                    <FormControl sx={{ width: '300px', height: "30px", backgroundColor: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: 1, border: "1px solid rgba(255, 255, 255, 0.1)", display: "flex", justifyContent: "center" }}>
                        <TextField size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                            InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                    </FormControl>
                </div>
                {IssuedStoreDataDownloadQr?.length > 0 ? IssuedStoreDataDownloadQr?.filter((item) => item?.isSelected !== true).filter((element) => element?.name?.toLowerCase().includes(searchName?.toLowerCase())).map((selectData) => {
                    return (
                        <Box key={selectData?.id} sx={{ borderRadius: '12px', background: 'rgba(255,255,255,0.05)', padding: '0.3rem', marginBottom: '10px' }} onClick={() => handleClickFRegisteredAsset(selectData?.id)}>
                            <div style={{ display: "flex", flexDirection: "column", alignContent: "flex-start", padding: 8 }}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "3px 0" }}>{selectData?.code}</Typography>
                                <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#FFF", padding: "3px 0" }}>{selectData?.name}</Typography>
                                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "3px 0" }}>{selectData.description}</Typography>
                            </div>
                        </Box>
                    )
                }) :
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                            <img style={{ heigth: '54px', width: '68px' }} src={requestEmptyIcon} alt="" />
                        </div>
                        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                            <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Items Yet</Typography>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    return {
        IssuedStoreDataDownloadQr: state?.attendanceConfig?.IssuedStoreDataDownloadQr,
        SelectedStoreDatas: state?.attendanceConfig?.SelectedStoreDatas,
    }
}

export default DeRegisterAsset;